import { SearchCriteria } from "src/app/components/new-product/home/base/search-criteria";

export class MfHkSearchCriteria extends SearchCriteria {
  constructor() {
    super();
  }

  interfaceDateFrom?: Date;
  interfaceDateTo?: Date;
  mortgageLoanAccountNumber1?: string;
  insuredPropertyAddress?: string;
  migrated?: string;
}

